module.exports = {
	"classes": [
		"new-homepage-page",
		"header-dark"
	],
	"title": "Single Sign On & Token Based Authentication",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ab-variants/new-homepage/data/metadata.json
// module id = 1098
// module chunks = 0